import React, {useContext, useEffect, useState} from "react";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import CallToActionIcon from "@material-ui/icons/CallToAction";
import DoneIcon from "@material-ui/icons/Done";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import { Trad } from "src/components";
import { _ButtonAPI, _Dialog } from "..";
import useToggle from "../../../hooks/Toggle";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";
import {useParams} from "react-router-dom";
import {IRouteParam} from "../../pages/Bond";
import {_DateField} from "../../form";
import moment from "moment";
import {DatePicker, KeyboardDatePicker} from "@material-ui/pickers";

interface IChangeStatusDialogProps {
    Open: boolean;
    ID_Polizza: string;
    GetData: () => void;
    OnClose: () => void;
}

export const _ChangeStatusDialog: React.FC<IChangeStatusDialogProps> = ({ Open, ID_Polizza, GetData, OnClose }) => {
    const { ShowDialog } = useContext(AlertDialogContext);
    const [DateRelease, setDateRelease] = useState(new Date());

    const GetFormData = (): any => ({
        ID_Polizza: ID_Polizza,
        DateRelease: DateRelease
    });

    const OnClickChangeStatus = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE", Trad.Trad(data.ErrTesto), "error");
        } else {
            ShowDialog("SVINCOLO", Trad.Trad("Richiesta cambio stato avvenuto con successo"), "success");
            GetData();
        }
    };

    const OnError = (error: Error) => {
        OnClose();
        ShowDialog("ERRORE", error.message, "error");
    };
    
    const ParametrsChangeState: { [Param: string]: any } = [];
    ParametrsChangeState["id_Polizza"] = ID_Polizza;
    ParametrsChangeState["dateRelease"] = moment(DateRelease).utc().format();
    
    return (
        <>
            <_Dialog
                Open={Open}
                Title={Trad.Trad("Svincolo")}
                Type="warning"
                Actions={
                    <>
                        <_ButtonAPI
                            URL="/api/polizza/ChangeStateToRelease"
                            Testo={Trad.Trad("Svincolo")}
                            Metodo="POST" 
                            ParamURLLista={ParametrsChangeState}
                            OnClick={OnClickChangeStatus}
                            OnErrore={OnError}
                            Icona={<ThumbUpAltIcon />}
                        />
                    </>
                }
                OnClose={OnClose}
            >
                <form noValidate>
                    <KeyboardDatePicker
                        autoOk
                        fullWidth
                        color="secondary"
                        variant="inline"
                        format="DD/MM/YYYY"
                        label="Data svincolo"
                        value={DateRelease}
                        onChange={date => {
                            if (date) {
                                setDateRelease(date.toDate())
                            }}}
                        invalidDateMessage={Trad.Trad("Invalid Date Format")}
                        KeyboardButtonProps={{"aria-label": "change date"}}
                    />
                </form>
            </_Dialog>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/Bond/ChangeStatusDialog.tsx